import * as XLSX from 'xlsx';

function triggerDownload(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

/**
 * Export data to CSV and trigger download.
 * @param {Array<Object>} rows
 * @param {string[]} headers - column display names
 * @param {string[]} keys - object keys corresponding to each header
 * @param {string} filename - without extension
 */
export function exportToCSV(rows, headers, keys, filename) {
  const lines = [
    headers.join(','),
    ...rows.map((row) =>
      keys
        .map((k) => {
          const val = (row[k] ?? '').toString();
          return val.includes(',') || val.includes('"') || val.includes('\n')
            ? `"${val.replace(/"/g, '""')}"`
            : val;
        })
        .join(',')
    ),
  ];
  const blob = new Blob([lines.join('\n')], { type: 'text/csv;charset=utf-8;' });
  triggerDownload(blob, `${filename}.csv`);
}

/**
 * Export data to Excel (.xlsx) and trigger download.
 */
export function exportToExcel(rows, headers, keys, filename) {
  const data = rows.map((row) => {
    const obj = {};
    headers.forEach((h, i) => {
      obj[h] = row[keys[i]] ?? '';
    });
    return obj;
  });
  const ws = XLSX.utils.json_to_sheet(data);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Results');
  const buf = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
  const blob = new Blob([buf], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  triggerDownload(blob, `${filename}.xlsx`);
}
